import { connect } from "vuex-connect";
import { PurchaseSettlementPaypal } from "../../components";

export default connect({
  actionsToProps: {
    postPurchaseSettlementPaypalOrder: (dispatch, value) =>
      dispatch(
        "purchaseSettlementPaypal/postPurchaseSettlementPaypalOrder",
        value
      ),
    postPurchaseSettlementPaypalApprove: (dispatch, value) =>
      dispatch(
        "purchaseSettlementPaypal/postPurchaseSettlementPaypalApprove",
        value
      )
  },
  mutationsToProps: {
    updateIsBusy: "common/updateIsBusy"
  },
  stateToProps: {
    isBusy: state => state.common.isBusy
  }
})(PurchaseSettlementPaypal.extendOptions.name, PurchaseSettlementPaypal);
